import { RICH_TEXT_CONTENT_CLASS } from "@jugl-web/domain-resources/common/components/RichTextarea";
import { InteractiveContainer } from "@jugl-web/ui-kit";
import { cx } from "@jugl-web/utils";
import React, { useEffect, useState } from "react";
import { useWhatsappTemplateBodyRenderer } from "../../../WhatsappLogsHistoryTab/components/AccountLogDetailsDialog/hooks/useWhatsappTemplateBodyRenderer";
import { ReactComponent as WhatsappIcon } from "./assets/whatsapp.svg";

export const TemplateNameTile: React.FC<{
  name: string;
  body: string;
  variables: string[];
  boardId?: string;
  onClick: () => void;
}> = ({ name, body, variables, boardId, onClick }) => {
  const { renderHtml } = useWhatsappTemplateBodyRenderer(boardId);
  const [html, setHtml] = useState("");

  useEffect(() => {
    let isActive = true;
    renderHtml({ body, variables }).then((next) => {
      if (isActive) setHtml(next);
    });
    return () => {
      isActive = false;
    };
  }, [body, renderHtml, variables]);

  return (
    <InteractiveContainer
      onClick={onClick}
      className="flex h-full w-full items-center gap-4 p-4 whitespace-normal"
    >
      <WhatsappIcon className="shrink-0 [transform:translateZ(0)] [will-change:transform] [backface-visibility:hidden]" />
      <div className="flex flex-col gap-0.5">
        <span className="font-secondary leading-[140%] font-medium tracking-[0.16px] text-dark-800">
          {name}
        </span>
        <div
          className={cx(
            "font-secondary leading-[140%] tracking-[0.14px] text-grey",
            RICH_TEXT_CONTENT_CLASS
          )}
          // oxlint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
    </InteractiveContainer>
  );
};
